import analytics from '@utils/analytics';
import Swiper, { A11y, Navigation, Mousewheel } from 'swiper';
import BaseComponent from '../base/baseComponent';
Swiper.use([A11y, Navigation, Mousewheel]);
export default class ProductCarouselComponent extends BaseComponent {
    constructor(element) {
        super(element);
        // carousel arrow next/prev not announced by SR and not tabbable with keyboard [OE-13874]
        this.arrowButtonDisabledA11y = () => {
            document.addEventListener('keydown', function (event) {
                if (event.key === 'Tab') {
                    const carouselArrow = document.querySelectorAll('.carousel-container__navigation-button');
                    carouselArrow.forEach((el) => {
                        el.setAttribute('tabindex', '-1');
                    });
                }
            });
        };
        this.initSlider();
        this.arrowButtonDisabledA11y();
    }
    initSlider() {
        var _a;
        const { editorialComponents } = window;
        const products = (_a = editorialComponents[this.$options.uuid]) === null || _a === void 0 ? void 0 : _a.products.map((p) => (Object.assign(Object.assign({}, p), { analyticsAttributes: Object.assign(Object.assign({}, p.analyticsAttributes), { list: `recommended_${this.$options.type}` }) })));
        if (!products && !this.$options.isEditorial)
            return;
        if (products) {
            analytics.productImpressions(products, 0);
        }
        // wait for react app to load
        const intervalid = setInterval(() => {
            const recoCarousels = this.$el.querySelectorAll('[data-react="recommendationscarousel-app"]');
            const recoCarouselsCategory = this.$el.querySelectorAll('.recommendationscarousel');
            if (recoCarousels.length > 0) {
                let recoLoaded = 0;
                recoCarousels.forEach((el) => {
                    if (el.classList.contains('products-loaded')) {
                        recoLoaded++;
                    }
                });
                if (recoLoaded == recoCarousels.length) {
                    clearTimeout(intervalid);
                }
                else {
                    return;
                }
            }
            else {
                this.$el.classList.remove('skeleton-loading');
                clearTimeout(intervalid);
            }
            (recoCarousels.length > 0 ? recoCarousels : [this.$el]).forEach((container) => {
                var _a;
                const mainSlider = container.querySelector('.swiper-container');
                if ((recoCarouselsCategory.length > 0 || recoCarousels.length > 0) && mainSlider.childElementCount <= 1) {
                    return;
                }
                // const prevButton = container.querySelector('.swiper-button-prev');
                // const nextButton = container.querySelector('.swiper-button-next');
                container.addEventListener('mousemove', ({ pageX }) => {
                    const percentage = (pageX / container.offsetWidth) * 100;
                    if (percentage < 25) {
                        container.classList.add('show-left-arrow');
                        container.classList.remove('show-right-arrow');
                    }
                    else if (percentage > 75) {
                        container.classList.add('show-right-arrow');
                        container.classList.remove('show-left-arrow');
                    }
                    else {
                        container.classList.remove('show-right-arrow');
                        container.classList.remove('show-left-arrow');
                    }
                });
                container.addEventListener('mouseleave', () => {
                    container.classList.remove('show-right-arrow');
                    container.classList.remove('show-left-arrow');
                });
                const slider = new Swiper(mainSlider, {
                    grabCursor: true,
                    slidesPerView: this.$options.mobileExtraSmallTiles
                        ? this.$options.smallTiles || this.$options.mobileOnlySmallTiles
                            ? 1.8
                            : 1.7
                        : this.$options.smallTiles || this.$options.mobileOnlySmallTiles
                            ? 1.1
                            : 1,
                    // slidesPerView: this.$options.smallTiles || this.$options.mobileOnlySmallTiles ? 1.8 : 1.7,
                    slidesPerGroup: 1,
                    speed: 1000,
                    spaceBetween: this.$options.internalGutter ? 4 : 0,
                    threshold: 10,
                    watchSlidesProgress: true,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    mousewheel: {
                        forceToAxis: true,
                        thresholdDelta: 20,
                    },
                    breakpoints: {
                        1200: {
                            slidesPerView: this.$options.smallTiles ? 4.1 : this.$options.biggerSlide ? 3 : 4,
                            slidesPerGroup: 1,
                        },
                        600: {
                            slidesPerView: this.$options.smallTiles ? 3.1 : 3,
                            slidesPerGroup: 1,
                        },
                    },
                    a11y: {
                        slideRole: 'listitem',
                        slideLabelMessage: '',
                        enabled: true,
                        prevSlideMessage: this.$options.prevslidemessage,
                        nextSlideMessage: this.$options.nextslidemessage,
                        firstSlideMessage: this.$options.firstslidemessage,
                        lastSlideMessage: this.$options.lastslidemessage,
                        paginationBulletMessage: (_a = this.$options.paginationbulletmessage) === null || _a === void 0 ? void 0 : _a.replace('INDEX_NUMBER', '{{index}}'),
                    },
                });
                // prevButton.addEventListener('click', () => {
                //   slider.slideTo(slider.activeIndex - (window.isDesktop() ? (this.$options.biggerSlide ? 3 : 4) : 1));
                // });
                // nextButton.addEventListener('click', () => {
                //   slider.slideTo(slider.activeIndex + (window.isDesktop() ? (this.$options.biggerSlide ? 3 : 4) : 1));
                // });
                window.swiperContainers[this.$options.uuid + container.dataset.id] = slider;
            });
            (recoCarouselsCategory.length > 0 ? recoCarouselsCategory : [this.$el]).forEach((container) => {
                var _a;
                const mainSlider = container.querySelector('.swiper-container');
                if ((recoCarouselsCategory.length > 0 || recoCarousels.length > 0) && mainSlider.childElementCount <= 1) {
                    return;
                }
                // const prevButton = container.querySelector('.swiper-button-prev');
                // const nextButton = container.querySelector('.swiper-button-next');
                container.addEventListener('mousemove', ({ pageX }) => {
                    const percentage = (pageX / container.offsetWidth) * 100;
                    if (percentage < 25) {
                        container.classList.add('show-left-arrow');
                        container.classList.remove('show-right-arrow');
                    }
                    else if (percentage > 75) {
                        container.classList.add('show-right-arrow');
                        container.classList.remove('show-left-arrow');
                    }
                    else {
                        container.classList.remove('show-right-arrow');
                        container.classList.remove('show-left-arrow');
                    }
                });
                container.addEventListener('mouseleave', () => {
                    container.classList.remove('show-right-arrow');
                    container.classList.remove('show-left-arrow');
                });
                const slider = new Swiper(mainSlider, {
                    grabCursor: true,
                    slidesPerView: this.$options.mobileExtraSmallTiles
                        ? this.$options.smallTiles || this.$options.mobileOnlySmallTiles
                            ? 1.8
                            : 1.7
                        : this.$options.smallTiles || this.$options.mobileOnlySmallTiles
                            ? 1.1
                            : 1,
                    slidesPerGroup: 1,
                    speed: 1000,
                    spaceBetween: this.$options.internalGutter ? 4 : 0,
                    threshold: 10,
                    watchSlidesProgress: true,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                    },
                    breakpoints: {
                        1200: {
                            slidesPerView: this.$options.smallTiles ? 4.1 : this.$options.biggerSlide ? 3 : 4,
                            slidesPerGroup: 1,
                        },
                        600: {
                            slidesPerView: this.$options.smallTiles ? 3.1 : 3,
                            slidesPerGroup: 1,
                        },
                    },
                    a11y: {
                        slideRole: 'listitem',
                        slideLabelMessage: '',
                        enabled: true,
                        prevSlideMessage: this.$options.prevslidemessage,
                        nextSlideMessage: this.$options.nextslidemessage,
                        firstSlideMessage: this.$options.firstslidemessage,
                        lastSlideMessage: this.$options.lastslidemessage,
                        paginationBulletMessage: (_a = this.$options.paginationbulletmessage) === null || _a === void 0 ? void 0 : _a.replace('INDEX_NUMBER', '{{index}}'),
                    },
                });
                // prevButton.addEventListener('click', () => {
                //   slider.slideTo(slider.activeIndex - (window.isDesktop() ? (this.$options.biggerSlide ? 3 : 4) : 1));
                // });
                // nextButton.addEventListener('click', () => {
                //   slider.slideTo(slider.activeIndex + (window.isDesktop() ? (this.$options.biggerSlide ? 3 : 4) : 1));
                // });
                window.swiperContainers[this.$options.uuid + container.dataset.id] = slider;
            });
        }, 500);
        if (this.$options.tabswitch) {
            const switches = this.$el.querySelectorAll('button[data-switch]');
            const handleSwitchClick = (e) => {
                var _a, _b, _c, _d;
                switches.forEach((el) => el.classList.remove('active'));
                e.currentTarget.classList.add('active');
                this.$el.querySelectorAll('.recommendationscarousel').forEach((el) => el.classList.add('product-carousel__is-hidden'));
                this.$el.querySelector(`[data-id="${(_a = e.currentTarget.dataset) === null || _a === void 0 ? void 0 : _a.switch}"]`).classList.remove('product-carousel__is-hidden');
                this.$el.querySelector(`[data-id="${(_b = e.currentTarget.dataset) === null || _b === void 0 ? void 0 : _b.switch}"]`).classList.remove('d-none');
                (_d = window.swiperContainers[this.$options.uuid + ((_c = e.currentTarget.dataset) === null || _c === void 0 ? void 0 : _c.switch)]) === null || _d === void 0 ? void 0 : _d.update();
            };
            switches.forEach((el) => el.addEventListener('click', handleSwitchClick));
        }
    }
}
